/** API route map: URLS.Controller.Monster */
export const Monster = {
      Name: 'Monster/',
      AddConfiguration: 'add-monster-configuration',
};
